/* Krelune Ritual. Native Shopify forms remain the source of truth. */
if (!customElements.get('kr-pack-picker')) {
  customElements.define('kr-pack-picker', class extends HTMLElement {
    connectedCallback() {
      this.info = this.closest('product-info');
      this.onChange = this.handleChange.bind(this);
      this.info?.addEventListener('change', this.onChange);
      this.originalDisabled = new WeakMap();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (String(data.sectionId) !== this.dataset.sectionId) return;
          const incoming = [...data.html.querySelectorAll('kr-pack-picker')].find(el => el.dataset.blockId === this.dataset.blockId);
          if (incoming) { this.innerHTML = incoming.innerHTML; this.originalDisabled = new WeakMap(); }
          this.sync();
        });
        this.quantityUnsubscribe = subscribe(PUB_SUB_EVENTS.quantityUpdate, () => this.sync());
      }
      this.sync();
    }
    disconnectedCallback() {
      this.info?.removeEventListener('change', this.onChange);
      this.unsubscribe?.();
      this.quantityUnsubscribe?.();
    }
    get quantityInput() {
      return document.querySelector(`input[name="quantity"][form="${CSS.escape(this.dataset.formId)}"]`)
        || document.getElementById(this.dataset.formId)?.querySelector('input[name="quantity"]');
    }
    handleChange(event) {
      const target = event.target;
      if (this.contains(target) && target.matches('input[type="radio"]')) {
        const input = this.quantityInput;
        if (!input || target.disabled) return;
        const value = Number(target.value);
        const min = Number(input.min || 1), max = Number(input.max || Infinity), step = Number(input.step || 1);
        if (!Number.isInteger(value) || value < min || value > max || (value-min)%step !== 0) return;
        input.value = String(value);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (target === this.quantityInput) this.sync();
    }
    sync() {
      const input = this.quantityInput;
      if (!input) return;
      const value = Number(input.value);
      const min = Number(input.min || 1), max = Number(input.max || Infinity), step = Number(input.step || 1);
      this.querySelectorAll('input[type="radio"]').forEach(radio => {
        const count = Number(radio.value);
        if (!this.originalDisabled.has(radio)) this.originalDisabled.set(radio, radio.disabled);
        radio.disabled = this.originalDisabled.get(radio) || count < min || count > max || (count-min)%step !== 0;
        radio.checked = count === value && !radio.disabled;
      });
    }
  });
}


if (!customElements.get('kr-sticky-buy')) {
 customElements.define('kr-sticky-buy', class extends HTMLElement {
  connectedCallback() {
   this.info = this.closest('product-info');
   this.form = document.getElementById(this.dataset.formId);
   this.originalButton = this.form?.querySelector('[type="submit"][name="add"]');
   this.button = this.querySelector('[data-sticky-submit]');
   if (!this.form || !this.originalButton || !this.button) return;
   this.abort = new AbortController(); const options = { signal: this.abort.signal };
   this.button.addEventListener('click', () => {
    if (!this.originalButton.disabled && this.originalButton.getAttribute('aria-disabled') !== 'true') this.form.requestSubmit(this.originalButton);
   }, options);
   this.addEventListener('change', event => { if (event.target.matches('[data-sticky-variant]')) this.changeVariant(event.target); }, options);
   this.info.addEventListener('change', () => this.sync(), options);
   this.updateVisibility = () => { cancelAnimationFrame(this.visibilityFrame); this.visibilityFrame = requestAnimationFrame(() => { this.hidden = this.originalButton.getBoundingClientRect().bottom > 0; }); };
   this.observer = new IntersectionObserver(this.updateVisibility, { threshold: 0 });
   window.addEventListener('scroll', this.updateVisibility, { ...options, passive: true });
   window.addEventListener('resize', this.updateVisibility, options);
   this.observer.observe(this.originalButton);
   this.mutations = new MutationObserver(() => this.sync());
   this.mutations.observe(this.originalButton, { attributes: true, childList: true, subtree: true, characterData: true });
   this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    if (String(data.sectionId) !== this.dataset.sectionId) return;
    const incoming = data.html.querySelector(`kr-sticky-buy[data-section-id="${CSS.escape(this.dataset.sectionId)}"]`);
    if (incoming) {
     this.dataset.unitPrice = incoming.dataset.unitPrice;
     const select = this.querySelector('[data-sticky-variant]'); const newSelect = incoming.querySelector('[data-sticky-variant]');
     if (select && newSelect) select.innerHTML = newSelect.innerHTML;
    }
    this.sync();
   });
   this.quantityUnsubscribe = subscribe(PUB_SUB_EVENTS.quantityUpdate, () => this.sync());
   this.sync();
  }
  async changeVariant(select) {
   if (window.KreluneSelectVariant) {
    const original = this.form.querySelector('[name=id]').value;
    select.disabled = true;
    try { const ok = await window.KreluneSelectVariant(this.info, select.value, this.dataset.sectionId); if (!ok) select.value = original; }
    finally { select.disabled = false; this.sync(); }
    return;
   }
   const requested = select.value;
   const original = this.form.querySelector('[name=id]').value;
   const originalLabel = this.originalButton.querySelector('span')?.textContent;
   this.info.abortController?.abort();
   this.variantRequest?.abort(); this.variantRequest = new AbortController();
   this.info.abortController = this.variantRequest;
   this.originalButton.setAttribute('aria-disabled','true');
   select.disabled = true;
   try {
    // Native product-info renders all option values, prices, inventory and quantity rules.
    const url = new URL(this.info.dataset.url, location.origin);
    url.searchParams.set('variant', requested); url.searchParams.set('section_id', this.dataset.sectionId);
    const response = await fetch(url, { signal: this.variantRequest.signal });
    if (!response.ok) throw new Error('Variant unavailable');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const variant = this.info.getSelectedVariant(html);
    if (!variant || String(variant.id) !== requested) throw new Error('Variant unavailable');
    this.info.handleUpdateProductInfo(this.info.dataset.url)(html);
   } catch(error) {
    if (error.name !== 'AbortError') {
     select.value = original;
     this.info.productForm.handleErrorMessage(window.variantStrings?.unavailable || 'Please choose your variant again.');
     if (originalLabel) this.originalButton.querySelector('span').textContent = originalLabel;
    }
   } finally { select.disabled = false; this.originalButton.removeAttribute('aria-disabled'); this.sync(); }
  }
  sync() {
   this.button.disabled = this.originalButton.disabled || this.originalButton.getAttribute('aria-disabled') === 'true';
   this.button.textContent = this.originalButton.querySelector('span:not(.loading__spinner)')?.textContent.trim() || this.originalButton.textContent.trim();
   const quantity = this.info.querySelector('input[name=quantity]')?.value || 1;
   const target = this.querySelector('[data-sticky-price]');
   if (target && window.KreluneCommerce) target.textContent = window.KreluneCommerce.money(Number(this.dataset.unitPrice) * Number(quantity));
  }
  disconnectedCallback() { cancelAnimationFrame(this.visibilityFrame); this.abort?.abort(); this.variantRequest?.abort(); this.observer?.disconnect(); this.mutations?.disconnect(); this.unsubscribe?.(); this.quantityUnsubscribe?.(); }
 });
}

/* Only one merchant video plays at a time. No third-party embeds or trackers. */
document.addEventListener('play', event => {
  if (!(event.target instanceof HTMLVideoElement) || !event.target.closest('.kr-videos')) return;
  document.querySelectorAll('.kr-videos video').forEach(video => { if (video !== event.target) video.pause(); });
}, true);
